angular
    .module("thor.shared.published-icons-list.component", [])
    .component("publishedIconsList", {
        bindings: {
            auction: "<",
            auctionLive: "<",
            interencheres: "<",
            interencheresLive: "<",
            isOnline: "<"
        },
        controller: class {
            public auction: boolean;
            public auctionLive: boolean;
            public interencheres: boolean;
            public interencheresLive: boolean;
            public isOnline: boolean;
        },
        template: require("./published-icons-list.html")
    });
